module.exports = __webpack_public_path__ + "img/years-img.1b78e1a1.png";